const CpapRegisterData = {
  SerialNumber: "",
  CpapID: "",
  Brand: "",
  Model: "",
  Type: "",
  Vendor: "",
  DeviceNo: "",
  LotNo: "",
  IncomingDate: "",
  WarrantyStart: "",
  WarrantyEnd: "",
  MaintenancePeriod: "",
  Condition: "",
  CreatedBy: "",
  CreatedDateTime: "",
  UpdatedDateTime: "",
  BrandOther: "",
  TypeOther: "",
  ResponsiblePerson: "",
  LastHN: "",
  LastBorrowDate: null,
  LastDueDate: null,
  LastBorrowCondition: "",
  LastReturnDate: null,
  LastReturnCondition: "",
  LastNote: "",
  Activity: "",
  Status: "",
  LastTel: "",
  LastFirstName: "",
  LastLastName: "",
};

const Brand = [
  "ResMed",
  "Apex",
  "BMC",
  "Yuwell",
  "VentMed",
  "Topson",
  "Philips",
  "Other",
];
const Type = ["APAP", "BPAP", "CPAP", "Other"];

const ResponsiblePerson = [
  "Center",
  "A.Rafa",
  "P.Narongchai",
  "P.Noppasit",
  "P.Preeyakorn",
  "S.Proudnaphat",
  "B.Sunisa",
];

const CpapRegisterChoices = {
  SerialNumber: "",
  CpapID: "",
  Brand: Brand,
  Model: "",
  Type: Type,
  Vendor: "",
  DeviceNo: "",
  LotNo: "",
  IncomingDate: "",
  WarrantyStart: "",
  WarrantyEnd: "",
  MaintenancePeriod: ["6 Months", "1 Year"],
  Condition: "",
  CreatedBy: "",
  CreatedDateTime: "",
  UpdatedDateTime: "",
  Activity: [
    "ยืมเครื่อง",
    "คืนเครื่อง",
    "ส่งทำความสะอาด",
    "ส่งซ่อม",
    "ลงทะเบียน",
  ],
  Status: ["ว่าง", "ไม่ว่าง", "ยกเลิกใช้งาน", "ขาย"],
  BrandOther: "",
  TypeOther: "",
  ResponsiblePerson: ResponsiblePerson,
};

// ว่าง ครั้งแรกสถานะคือลงทะเบียน เมื่อกดส่งคืนเครื่อง
// ไม่ว่าง ตอนเครื่องถูกยืม , ตอนเครื่องส่งซ่อม
// activity : ทำความสะอาด
// ยกเลิกใช้งาน ตอน กด On / Off ว่าให้ใช้งานหรือไม่ใช้งาน

export { CpapRegisterData, CpapRegisterChoices };
